import { HttpClient } from '@angular/common/http';
import { from } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ReportService = /** @class */ (function () {
    function ReportService(http) {
        this.http = http;
    }
    ReportService.prototype.getDistinctTransformerId = function () {
        return this.http.get('getDistinctTransformerId');
    };
    ReportService.prototype.getDistinctSite = function () {
        return this.http.get('getDistinctSite');
    };
    ReportService.prototype.getParametersByTransformerId = function (transformerId) {
        return this.http.get("getParameters/" + encodeURIComponent(transformerId));
    };
    ReportService.prototype.getAlertReportData = function (payload) {
        var url = '';
        console.log('PAyload:', payload);
        return this.http.post('getAlertsReport', payload);
    };
    ReportService.prototype.getObjectReport = function (payload) {
        console.log('payload:', payload);
        return this.http.post('objectAndIntrusionDetectionReport', payload);
    };
    ReportService.prototype.getAlertsData = function (roleid, userid) {
        var url = '';
        return this.http.get("getAlertsData?roleid=" + roleid + "&userid=" + userid);
    };
    ReportService.prototype.getReportData = function (payload) {
        var url = '';
        // console.log('FILTERS:', filter);
        // if(filter.length > 0) {
        //     url = `getReport1?` + filter;
        // }
        //  else if(filter.transformerId && filter.date) {
        //      url = `getReport1?transformerId=${filter.transformerId}` + '&' + `date=${filter.date}`
        //      console.log('URL:', url);
        //  }
        // else {
        //     url = `getReport1`;
        // }
        console.log('PAyload:', payload);
        return this.http.post('getReport1', payload);
    };
    ReportService.prototype.getTapPosition = function (payload) {
        return this.http.post('getTapPosition', payload);
    };
    ReportService.prototype.getDailyConsumptionReport = function (deviceid) {
        return this.http.get("getDailyConsumptionReport?deviceid=" + deviceid, { responseType: 'blob' });
    };
    ReportService.prototype.uploadFolder = function (files) {
        var _this = this;
        var batchSize = 300; // Set the batch size to 300
        var fileBatches = [];
        // Split the files into batches
        for (var i = 0; i < files.length; i += batchSize) {
            var batch = files.slice(i, i + batchSize);
            fileBatches.push(batch);
        }
        // Use from and concatMap to process batches sequentially
        return from(fileBatches).pipe(concatMap(function (batch) {
            var formData = new FormData();
            batch.forEach(function (file) {
                formData.append('files', file, file.webkitRelativePath); // Maintain folder structure
            });
            // Send each batch to the API and return the response
            return _this.http.post('uploadlogfolder', formData);
        }));
    };
    ReportService.prototype.getUploadData = function () {
        return this.http.get("saveFileData");
    };
    ReportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportService_Factory() { return new ReportService(i0.ɵɵinject(i1.HttpClient)); }, token: ReportService, providedIn: "root" });
    return ReportService;
}());
export { ReportService };
